import React, { useEffect, useState } from "react";
import student1 from "../../img/figure/student1.png";
import $ from "jquery";
import { Chart } from "chart.js/auto";
import Cta from "../../Shared/Cta";
import { Link } from "react-router-dom";

const Student = () => {
  useEffect(() => {
    $(".checkAll").on("click", function () {
      $(this)
        .parents(".table")
        .find("input:checkbox")
        .prop("checked", this.checked);
    });
  }, []);
  useEffect(() => {
    if ($("#student-doughnut-chart").length) {
      var doughnutChartData = {
        labels: ["Female Students", "Male Students"],
        datasets: [
          {
            backgroundColor: ["#304ffe", "#ffa601"],
            data: [45000, 105000],
            label: "Total Students",
          },
        ],
      };
      var doughnutChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 65,
        rotation: -9.4,
        animation: {
          duration: 2000,
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
        },
      };
      var studentCanvas = $("#student-doughnut-chart").get(0).getContext("2d");
      var studentChart = new Chart(studentCanvas, {
        type: "doughnut",
        data: doughnutChartData,
        options: doughnutChartOptions,
      });
    }
  }, []);
  useEffect(() => {
    if ($.fn.fullCalendar !== undefined) {
      $("#fc-calender").fullCalendar({
        header: {
          center: "basicDay,basicWeek,month",
          left: "title",
          right: "prev,next",
        },
        fixedWeekCount: false,
        navLinks: true, // can click day/week names to navigate views
        editable: true,
        eventLimit: true, // allow "more" link when too many events
        aspectRatio: 1.8,
        events: [
          {
            title: "All Day Event",
            start: "2019-04-01",
          },

          {
            title: "Meeting",
            start: "2019-04-12T14:30:00",
          },
          {
            title: "Happy Hour",
            start: "2019-04-15T17:30:00",
          },
          {
            title: "Birthday Party",
            start: "2019-04-20T07:00:00",
          },
        ],
      });
    }
  }, []);

  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Admin Dashboard</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>Student</li>
        </ul>
      </div>
      <div class="row">
        <div class="col-4-xxxl col-12">
          <div class="card dashboard-card-ten">
            <div class="card-body">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3>About Me</h3>
                </div>
                <Cta />
              </div>
              <div class="student-info">
                <div class="media media-none--xs">
                  <div class="item-img">
                    <img src={student1} class="media-img-auto" alt="student" />
                  </div>
                  <div class="media-body">
                    <h3 class="item-title">Jessia Rose</h3>
                    <p>
                      Aliquam erat volutpat. Curabiene natis massa sedde
                      lacustiquen sodale word moun taiery.
                    </p>
                  </div>
                </div>
                <div class="table-responsive info-table">
                  <table class="table text-nowrap">
                    <tbody>
                      <tr>
                        <td>Name:</td>
                        <td class="font-medium text-dark-medium">
                          Jessia Rose
                        </td>
                      </tr>
                      <tr>
                        <td>Gender:</td>
                        <td class="font-medium text-dark-medium">Female</td>
                      </tr>
                      <tr>
                        <td>Father Name:</td>
                        <td class="font-medium text-dark-medium">
                          Fahim Rahman
                        </td>
                      </tr>
                      <tr>
                        <td>Mother Name:</td>
                        <td class="font-medium text-dark-medium">
                          Jannatul Kazi
                        </td>
                      </tr>
                      <tr>
                        <td>Date Of Birth:</td>
                        <td class="font-medium text-dark-medium">07.08.2006</td>
                      </tr>
                      <tr>
                        <td>Religion:</td>
                        <td class="font-medium text-dark-medium">Islam</td>
                      </tr>
                      <tr>
                        <td>Father Occupation:</td>
                        <td class="font-medium text-dark-medium">
                          Graphic Designer
                        </td>
                      </tr>
                      <tr>
                        <td>E-Mail:</td>
                        <td class="font-medium text-dark-medium">
                          jessiarose@gmail.com
                        </td>
                      </tr>
                      <tr>
                        <td>Admission Date:</td>
                        <td class="font-medium text-dark-medium">05.01.2019</td>
                      </tr>
                      <tr>
                        <td>Class:</td>
                        <td class="font-medium text-dark-medium">2</td>
                      </tr>
                      <tr>
                        <td>Section:</td>
                        <td class="font-medium text-dark-medium">Pink</td>
                      </tr>
                      <tr>
                        <td>Roll:</td>
                        <td class="font-medium text-dark-medium">10005</td>
                      </tr>
                      <tr>
                        <td>Adress:</td>
                        <td class="font-medium text-dark-medium">
                          House #10, Road #6, Australia
                        </td>
                      </tr>
                      <tr>
                        <td>Phone:</td>
                        <td class="font-medium text-dark-medium">
                          + 88 9856418
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8-xxxl col-12">
          <div class="row">
            <div class="col-lg-4">
              <div class="dashboard-summery-one">
                <div class="row">
                  <div class="col-6">
                    <div class="item-icon bg-light-magenta">
                      <i class="flaticon-shopping-list text-magenta"></i>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="item-content">
                      <div class="item-title">Notification</div>
                      <div class="item-number">
                        <span class="counter" data-num="12">
                          12
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="dashboard-summery-one">
                <div class="row">
                  <div class="col-6">
                    <div class="item-icon bg-light-blue">
                      <i class="flaticon-calendar text-blue"></i>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="item-content">
                      <div class="item-title">Events</div>
                      <div class="item-number">
                        <span class="counter" data-num="06">
                          06
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="dashboard-summery-one">
                <div class="row">
                  <div class="col-6">
                    <div class="item-icon bg-light-yellow">
                      <i class="flaticon-percentage-discount text-orange"></i>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="item-content">
                      <div class="item-title">Attendance</div>
                      <div class="item-number">
                        <span class="counter" data-num="94">
                          94
                        </span>
                        <span>%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="card dashboard-card-eleven">
                <div class="card-body">
                  <div class="heading-layout1">
                    <div class="item-title">
                      <h3>All Exam Results</h3>
                    </div>
                    <Cta />
                  </div>
                  <div class="table-box-wrap">
                    <form class="search-form-box">
                      <div class="row gutters-8">
                        <div class="col-lg-4 col-12 form-group">
                          <input
                            type="text"
                            placeholder="Search by Exam ..."
                            class="form-control"
                          />
                        </div>
                        <div class="col-lg-3 col-12 form-group">
                          <input
                            type="text"
                            placeholder="Search by Subject ..."
                            class="form-control"
                          />
                        </div>
                        <div class="col-lg-3 col-12 form-group">
                          <input
                            type="text"
                            placeholder="dd/mm/yyyy"
                            class="form-control"
                          />
                        </div>
                        <div class="col-lg-2 col-12 form-group">
                          <button
                            type="submit"
                            class="fw-btn-fill btn-gradient-yellow"
                          >
                            SEARCH
                          </button>
                        </div>
                      </div>
                    </form>
                    <div class="table-responsive result-table-box">
                      <table class="table display data-table text-nowrap">
                        <thead>
                          <tr>
                            <th>
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input checkAll"
                                />
                                <label class="form-check-label">ID</label>
                              </div>
                            </th>
                            <th>Exam Name</th>
                            <th>Subject</th>
                            <th>Grade</th>
                            <th>Percent</th>
                            <th>Date</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                />
                                <label class="form-check-label">#0021</label>
                              </div>
                            </td>
                            <td>Class Test</td>
                            <td>English</td>
                            <td>A</td>
                            <td>99.00 100</td>
                            <td>22/02/2019</td>
                            <td>
                              <Cta />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                />
                                <label class="form-check-label">#0022</label>
                              </div>
                            </td>
                            <td>Class Test</td>
                            <td>English</td>
                            <td>A</td>
                            <td>99.00 100</td>
                            <td>22/02/2019</td>
                            <td>
                              <Cta />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                />
                                <label class="form-check-label">#0023</label>
                              </div>
                            </td>
                            <td>Class Test</td>
                            <td>Chemistry</td>
                            <td>A</td>
                            <td>99.00 100</td>
                            <td>22/02/2019</td>
                            <td>
                              <Cta />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                />
                                <label class="form-check-label">#0024</label>
                              </div>
                            </td>
                            <td>Class Test</td>
                            <td>English</td>
                            <td>A</td>
                            <td>99.00 100</td>
                            <td>22/02/2019</td>
                            <td>
                              <Cta />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                />
                                <label class="form-check-label">#0025</label>
                              </div>
                            </td>
                            <td>Class Test</td>
                            <td>Chemistry</td>
                            <td>A</td>
                            <td>99.00 100</td>
                            <td>22/02/2019</td>
                            <td>
                              <Cta />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                />
                                <label class="form-check-label">#0025</label>
                              </div>
                            </td>
                            <td>Class Test</td>
                            <td>Chemistry</td>
                            <td>D</td>
                            <td>70.00 100</td>
                            <td>22/02/2019</td>
                            <td>
                              <Cta />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                />
                                <label class="form-check-label">#0025</label>
                              </div>
                            </td>
                            <td>Class Test</td>
                            <td>English</td>
                            <td>C</td>
                            <td>80.00 100</td>
                            <td>22/02/2019</td>
                            <td>
                              <Cta />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                />
                                <label class="form-check-label">#0025</label>
                              </div>
                            </td>
                            <td>Class Test</td>
                            <td>English</td>
                            <td>B</td>
                            <td>99.00 100</td>
                            <td>22/02/2019</td>
                            <td>
                              <Cta />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                />
                                <label class="form-check-label">#0025</label>
                              </div>
                            </td>
                            <td>First Semister</td>
                            <td>English</td>
                            <td>A</td>
                            <td>99.00 100</td>
                            <td>22/02/2019</td>
                            <td>
                              <Cta />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4-xxxl col-xl-6 col-12">
          <div class="card dashboard-card-three">
            <div class="card-body">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3>Attendence</h3>
                </div>
                <Cta />
              </div>
              <div class="doughnut-chart-wrap">
                <canvas
                  id="student-doughnut-chart"
                  width="100"
                  height="270"
                ></canvas>
              </div>
              <div class="student-report">
                <div class="student-count pseudo-bg-blue">
                  <h4 class="item-title">Absent</h4>
                  <div class="item-number">28.2%</div>
                </div>
                <div class="student-count pseudo-bg-yellow">
                  <h4 class="item-title">Present</h4>
                  <div class="item-number">65.8%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4-xxxl col-xl-6 col-12">
          <div class="card dashboard-card-thirteen">
            <div class="card-body">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3>Event Calender</h3>
                </div>
                <Cta />
              </div>
              <div class="calender-wrap">
                <div id="fc-calender" class="fc-calender"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4-xxxl col-12">
          <div class="card dashboard-card-six">
            <div class="card-body">
              <div class="heading-layout1 mg-b-17">
                <div class="item-title">
                  <h3>Notifications</h3>
                </div>
                <Cta />
              </div>
              <div class="notice-box-wrap">
                <div class="notice-list">
                  <div class="post-date bg-skyblue">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">
                      Great School manag mene esom tus eleifend lectus sed
                      maximus mi faucibusnting.
                    </a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-yellow">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">Great School manag printing.</a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-pink">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">
                      Great School manag Nulla rhoncus eleifensed mim us mi
                      faucibus id. Mauris vestibulum non purus lobortismenearea
                    </a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-skyblue">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">
                      Great School manag mene esom text of the printing.
                    </a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-yellow">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">Great School manag printing.</a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
                <div class="notice-list">
                  <div class="post-date bg-pink">16 June, 2019</div>
                  <h6 class="notice-title">
                    <a href="#">Great School manag meneesom.</a>
                  </h6>
                  <div class="entry-meta">
                    Jennyfar Lopez / <span>5 min ago</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Student;
